import script from "./CreateTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTemp.vue?vue&type=script&setup=true&lang=js"

import "./CreateTemp.vue?vue&type=style&index=0&id=2e94e327&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e94e327"]])

export default __exports__